import type {
	SearchBarUmbBlockElementModel,
	SearchBarUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import {
	SearchBar,
	type SearchBarIntent,
} from "#/_packages/umbrella/features/search-bar/components/search-bar";
import { useGetSiteSettings } from "#/_packages/umbrella/hooks/useGetSiteSettings.ts";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";
import { toHoverItemCssClasses } from "#/_packages/umbrella/integrations/umbraco/utils/animation-utils";
import {
	tryGetAnimationScrollType,
	tryGetHeadingLevel,
	tryGetReadWidthLength,
} from "#/_packages/umbrella/utils";

type SearchBarBlockProps = BlockItemProps & {
	content: SearchBarUmbBlockElementModel;
	settings: SearchBarUmbBlockSettingsElementModel;
};

export default function SearchBarUmbBlock({
	className,
	content,
	settings,
}: SearchBarBlockProps) {
	const props = content.properties;
	const settingsProps = settings.properties;
	const siteSettings = useGetSiteSettings();

	return (
		<>
			<SearchBar
				className={className}
				heading={props?.heading ?? undefined}
				headingLabel={props?.headingLabel ?? undefined}
				headingLevel={tryGetHeadingLevel(props?.headingLevel)}
				body={
					props?.body?.markup ? (
						// biome-ignore lint/security/noDangerouslySetInnerHtml: Umbraco rich text is already rendered HTML from the CMS.
						<div
							className="rich-text"
							dangerouslySetInnerHTML={{ __html: props.body.markup }}
						/>
					) : undefined
				}
				intentColor={
					(props?.intentColor ?? undefined) as SearchBarIntent | undefined
				}
				customSearchEngine={props?.customSearchEngine?.toLowerCase() === "true"}
				searchPageUrl={siteSettings?.searchPage?.route.path ?? undefined}
				customUrl={props?.customUrl ?? undefined}
				customTargetBlank={props?.customTarget ?? undefined}
				id={settingsProps?.generatedId ?? undefined}
				readWidthToggle={settingsProps?.readWidthToggle ?? false}
				readWidthLength={tryGetReadWidthLength(
					settingsProps?.readWidthLengthPicker,
				)}
				animationHoverType={
					toHoverItemCssClasses(settingsProps?.animationHoverType) ?? undefined
				}
				animationScrollType={tryGetAnimationScrollType(
					settingsProps?.animationScrollType,
				)}
			/>
		</>
	);
}
